export var plans = [{
  value: '',
  title: 'Select your plan'
}, {
  value: 'freeTrialCustomer',
  title: 'Limited 3 day access to our visualizations'
}, {
  value: 'normalCustomer',
  title: 'COSMOS User: Unlimited access to visualizations, purchase data by time series'
}, {
  value: 'premiumCustomer',
  title: 'COSMOS Premium: Unlimited access to visualizations and unlimited downloads'
}];